import dayjs, { Dayjs } from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import moment from 'moment';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(customParseFormat);

export function formatDate(date: Date | string) {
  return moment(date).format('YYYY-MM-DD');
}

export function formatDayjs(date: Dayjs) {
  return date.format('YYYY-MM-DD');
}

export function formatDateTime(date: Date | string) {
  return moment(date).format('YYYY-MM-DD HH:mm');
}

export function currentTime() {
  return dayjs();
}

export function yesterday() {
  const today = new Date();
  today.setDate(today.getDate() - 1);
  return today;
}

export function yesterdayDayjs() {
  return dayjs().subtract(1, 'day');
}

export function addDays(date: Dayjs | string, days: number) {
  return dayjs(date).add(days, 'day').format('YYYY-MM-DD');
}

export function convertToPST(date: Dayjs | undefined) {
  if (date) {
    return date.tz('America/Los_Angeles');
  }
}

export function defaultCampaignStartTime() {
  const currentTime = dayjs().tz('America/Los_Angeles');
  const currentDayHour19 = dayjs()
    .tz('America/Los_Angeles')
    .hour(19)
    .startOf('hour');

  const startTime = currentTime.isAfter(currentDayHour19)
    ? currentTime.add(1, 'day').hour(19).startOf('hour')
    : currentDayHour19;

  return startTime;
}
